<template>
  <section id="dashboard" :class="getUserData().user_type_id == 2 ? 'customer-dashboard' : ''" class="bgCommon p-1">
    <div class="dashboard-data-wrapper mb-2 d-flex gap-2" v-if="infoData">
      <div class="info-data" v-if="ability.can('invoice_box', 'dashboard')">
        <b-link :to="{ name: 'invoices-list' }">
          <info-box title="發票" :amount="infoData.number_of_invoices" image_path="/assets/images/logo/Subtract(3).svg"
            :update-text="getDateTime() + '更新'" />
        </b-link>
      </div>
      <div class="info-data" v-if="ability.can('receipt_box', 'dashboard')">
        <b-link :to="{ name: 'receipts-list' }">
          <info-box title="收據" :amount="infoData.number_of_receipts" image_path="/assets/images/logo/Subtract(2).svg"
            :update-text="getDateTime() + '更新'" />
        </b-link>
      </div>
      <!-- <div class="info-data">
        <b-link
          :to="{ name: 'projects-list-with-status'}"
        >
          <info-box
            title="項目總數"
            :amount="infoData.number_of_project"
            image_path="/assets/images/logo/Subtract.svg"
            :update-text="getDateTime() + '更新'"
          />
        </b-link>
      </div> -->
      <div class="info-data" v-if="ability.can('project_box', 'dashboard')">
        <b-link :to="{ name: 'projects-list-in-progress' }">
          <info-box title="項目(進行中)" :amount="infoData.number_of_in_progress_project"
            image_path="/assets/images/logo/Subtract(1).svg" :update-text="getDateTime() + '更新'" />
        </b-link>
      </div>
      <div class="info-data" v-if="ability.can('project_qutation_box', 'dashboard')">
        <b-link :to="{ name: 'projects-list-in-quoting' }">
          <info-box title="項目(報價中)" :amount="infoData.number_of_quoting_project"
            image_path="/assets/images/logo/Subtract(4).svg" :update-text="getDateTime() + '更新'" />
        </b-link>
      </div>
    </div>
    <div class="d-flex flex-wrap project-expense-box">
      <!-- if customer login -->
      <div class="row mb-2" style="width: 102%">
        <div v-if="ability.can('project_expense', 'dashboard')"
          class="dashboard-box invoice-balance-box col-12 col-md-6 mb-2 mb-xl-50">
          <b-card v-if="infoData" class="body">
            <div v-if="invoiceBalanceList && invoiceBalanceList.length > 0" class="invoice-balance-table-wrapper">
              <div class="invoice-balance-thead">
                <div class="invoice-balance-th">發票編號</div>
                <div class="invoice-balance-th">發票總額</div>
                <div class="invoice-balance-th" style="width: 155px;">總成本</div>
                <div class="invoice-balance-th">結餘</div>
              </div>
              <div class="invoice-balance-body">
                <div v-for="item in invoiceBalanceList" :key="item.id" class="invoice-balance-row"
                  :class="{ 'invoice-balance-row-striped': true }">
                  <div class="invoice-balance-td">
                    <a v-if="ability.can('update', 'invoices') && item.invoice_number"
                      :href="`/invoice/edit/${item.id}`" target="_blank" class="text-primary">
                      {{ item.invoice_number }}
                    </a>
                    <span v-else>{{ item.invoice_number || '--' }}</span>
                  </div>
                  <div class="invoice-balance-td">${{ formatCost(item.total_amount) }}</div>
                  <div class="invoice-balance-td" style="width: 155px;">
                    <span class="d-inline-flex align-items-center">
                      ${{ formatCost(item.total_cost) }}
                      <b-button variant="link" size="sm" class="p-0 ml-1 text-secondary"
                        @click="toggleCostExpand(item.id)">
                        <feather-icon :icon="expandedInvoiceId === item.id ? 'ChevronUpIcon' : 'ChevronDownIcon'"
                          size="16" />
                      </b-button>
                    </span>
                    <div v-if="expandedInvoiceId === item.id" class="cost-breakdown mt-1 small text-muted">
                      <div>供應商帳單總額：${{ formatCost(item.supplier_bills_total) }}</div>
                      <div>薪金總額：${{ formatCost(item.salary_total) }}</div>
                      <div>預支總額：${{ formatCost(item.prepayment_total) }}</div>
                      <div>報銷總額：${{ formatCost(item.reimbursement_total) }}</div>
                    </div>
                  </div>
                  <div class="invoice-balance-td">${{ formatCost(item.balance) }}</div>
                </div>
              </div>
            </div>
            <div v-else class="d-grid place-items-center h-100">
              <h2>暫無數據</h2>
            </div>
          </b-card>
        </div>

        <div v-if="ability.can('messages', 'dashboard')"
          class="dashboard-box message-box col-12 col-md-6 mb-2 mb-xl-50">
          <b-card class="body">
            <!-- 內部通知區塊 -->
            <div class="d-flex top justify-content-between align-items-center mb-2">
              <h5 class="mb-0">內部通知</h5>
              <b-link v-if="ability.can('message_button', 'dashboard')" :to="{ name: 'messages-list' }">查看</b-link>
            </div>
            <div v-if="messageList && messageList.length > 0" class="info overflow-box-content">
              <ul>
                <li v-for="(message, index) of messageList" :key="`message${index}`">
                  <div class="header d-flex justify-content-between align-items-center py-50 px-2">
                    <div>
                      <span> 單號： </span>

                      <span>
                        {{ message.order_number }}
                      </span>
                    </div>

                    <div>
                      <span> 地址： </span>

                      <span>
                        {{ message.address }}
                      </span>
                    </div>
                  </div>
                  <div class="body py-50 px-2 mb-1">
                    <div>{{ message.content }}</div>
                    <div>{{ getDateTime(message.created_at) }}</div>
                  </div>
                </li>
              </ul>
            </div>
            <div v-else class="d-grid place-items-center h-100">
              <h2 style="margin-top: -5rem">暫無數據</h2>
            </div>
          </b-card>
        </div>

        <div v-if="ability.can('online_count', 'dashboard')"
          class="dashboard-box online-box col-12 col-md-6 mb-2 mb-xl-50">
          <b-card class="body">

              <div class="">
                <h5 class="text-center mx-auto py-1">
                  在線人數 {{ users && users.length }}
                </h5>
                <div d-flex align-items-center justify-content-center>
                  <div class="pt-2 overflow-box-content">
                    <dl v-for="(user, index) in users" :key="`user_${index}`">
                      <dt>
                        <b>{{ user.position }}</b>
                      </dt>
                      <dd class="d-flex align-items-center justify-content-between">
                        <span class="d-inline-block text-bolder">{{ user.name }}</span>
                        <div class="text-right">
                          <span :class="isAdminLogin ? 'colorGreen' : 'colorGrey'">線上</span>
                          ｜
                          <span :class="isAdminLogin ? 'colorGrey' : 'colorRed'">線下</span>
                       </div>
                      </dd>
                    </dl>
                  </div>
                </div>
              </div>

              <hr/>
              <!-- 工作天數計算區塊 -->
              <div class="work-days-calculator">
                <h6 class="mb-2">工作天數計算</h6>
                <div class="d-flex flex-column" style="gap: 0.75rem;">
                  <div class="d-flex" style="gap: 0.5rem;">
                    <div class="flex-fill">
                      <label class="form-label small">開始日期</label>
                      <el-date-picker v-model="workDaysStartDate" type="date" placeholder="選擇開始日期" size="small"
                        style="width: 100%;" format="yyyy-MM-dd" value-format="yyyy-MM-dd" />
                    </div>
                    <div class="flex-fill">
                      <label class="form-label small">結束日期</label>
                      <el-date-picker v-model="workDaysEndDate" type="date" placeholder="選擇結束日期" size="small"
                        style="width: 100%;" format="yyyy-MM-dd" value-format="yyyy-MM-dd" />
                    </div>
                  </div>
                  <div class="work-days-result p-2 bg-light rounded">
                    <div class="small text-muted mb-1">計算結果：</div>
                    <div v-if="workDaysResult.isValid">
                      <div class="d-flex justify-content-between mb-2">
                        <span>總天數：{{ workDaysResult.totalDays }}天</span>
                        <span>工作天數：<strong class="text-primary">{{ workDaysResult.workDays }}天</strong></span>
                      </div>
                      <div class="small text-muted">
                        <div v-if="workDaysResult.sundaysCount > 0" class="mb-1">
                          減去星期日：{{ workDaysResult.sundaysCount }}天
                        </div>
                        <div v-if="workDaysResult.holidaysCount > 0" class="mb-1">
                          減去公眾假期：{{ workDaysResult.holidaysCount }}天
                        </div>
                        <div v-if="workDaysResult.excludedHolidays.length > 0" class="holiday-list">
                          <div class="font-weight-bold mb-1">期間內的公眾假期：</div>
                          <div class="holiday-items">
                            <span v-for="(holiday, index) in workDaysResult.excludedHolidays" :key="index"
                              class="holiday-item badge badge-secondary mr-1 mb-1">
                              {{ holiday }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else class="text-muted small">
                      請選擇有效的開始和結束日期
                    </div>
                  </div>
                </div>
              </div>
          </b-card>
        </div>
      </div>
    </div>

    <edit-records-list v-if="ability.can('edit_record', 'dashboard')" :in-component="1" />
  </section>
</template>

<script>
import {
  BCard,
  BCardBody,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BTabs,
  BTab,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { formatCurrency } from "@core/utils/filter";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import dashboardStoreModule from "./dashboardStoreModule";
import infoBox from "./component/infoBox.vue";
import axiosIns from "@/libs/axios.js";
import columnChart from "./component/columnChart.vue";
import areaChart from "./component/areaChart.vue";
import editRecordsList from "@/views/edit-record/edit-records-list/editRecordsList.vue";
import ability from "@/libs/acl/ability";
import { getDateTime } from "@/libs/helper";
import { getUserData } from "@/auth/utils";

export default {
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BTabs,
    BTab,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
    infoBox,
    areaChart,
    columnChart,
    editRecordsList,
  },
  data() {
    return {
      ability,
      isAdminLogin: true,
      isStaff1Login: true,
      isStaff2Login: false,
      activeTabIndex: 0,
      filter_date_from: null,
      filter_date_to: null,
      dateRange: null,
      workDaysStartDate: null,
      workDaysEndDate: null,
    };
  },
  methods: {
    getUserData,
    getDateTime,
    formatCost(val) {
      const n = Number(val);
      return (Number.isFinite(n) ? n : 0).toFixed(2);
    },
    isActiveTab(index) {
      return index === this.activeTabIndex;
    },
    getFormatedDate(date) {
      // 检查是否为有效的日期对象
      if (date && date instanceof Date && !isNaN(date)) {
        const mm = date.getMonth() + 1; // getMonth() is zero-based
        const dd = date.getDate();

        return [
          date.getFullYear(),
          (mm > 9 ? "" : "0") + mm,
          (dd > 9 ? "" : "0") + dd,
        ].join("-");
      }
      return null; // 如果不是有效日期则返回 null
    },
    refetchExpenseData() {
      axiosIns.get("/info/project-expense", {
        params: {
          dateFrom: this.filter_date_from,
          dateTo: this.filter_date_to
        },
      }).then((response) => {
        console.log("response expense", response.data);
        this.infoData.project_expense = response.data.project_expense;
      });
    },
    // 獲取香港公眾假期（完整版本，支持未來10年）
    getHongKongHolidays(year) {
      const holidays = [];

      // 固定日期的公眾假期（每年都一樣）
      const fixedHolidays = [
        { month: 0, day: 1, name: '元旦' },
        { month: 4, day: 1, name: '勞動節' },
        { month: 6, day: 1, name: '香港特別行政區成立紀念日' },
        { month: 9, day: 1, name: '國慶日' },
        { month: 11, day: 25, name: '聖誕節' },
        { month: 11, day: 26, name: '聖誕節翌日' },
      ];

      fixedHolidays.forEach(holiday => {
        holidays.push({
          date: new Date(year, holiday.month, holiday.day),
          name: holiday.name
        });
      });

      // 完整的香港公眾假期數據（2023-2035年）
      // 數據來源：香港政府官方公布的公眾假期
      const completeHolidayData = {
        2023: [
          { date: new Date(2023, 0, 23), name: '農曆新年' },
          { date: new Date(2023, 0, 24), name: '農曆新年翌日' },
          { date: new Date(2023, 0, 25), name: '農曆新年第三日' },
          { date: new Date(2023, 3, 5), name: '清明節' },
          { date: new Date(2023, 3, 7), name: '耶穌受難節' },
          { date: new Date(2023, 3, 8), name: '耶穌受難節翌日' },
          { date: new Date(2023, 3, 10), name: '復活節星期一' },
          { date: new Date(2023, 4, 26), name: '佛誕' },
          { date: new Date(2023, 5, 22), name: '端午節' },
          { date: new Date(2023, 8, 30), name: '中秋節翌日' },
          { date: new Date(2023, 9, 23), name: '重陽節' },
        ],
        2024: [
          { date: new Date(2024, 1, 10), name: '農曆新年' },
          { date: new Date(2024, 1, 12), name: '農曆新年翌日' },
          { date: new Date(2024, 1, 13), name: '農曆新年第三日' },
          { date: new Date(2024, 2, 29), name: '耶穌受難節' },
          { date: new Date(2024, 2, 30), name: '耶穌受難節翌日' },
          { date: new Date(2024, 3, 1), name: '復活節星期一' },
          { date: new Date(2024, 3, 4), name: '清明節' },
          { date: new Date(2024, 4, 15), name: '佛誕' },
          { date: new Date(2024, 5, 10), name: '端午節' },
          { date: new Date(2024, 8, 18), name: '中秋節翌日' },
          { date: new Date(2024, 9, 11), name: '重陽節' },
        ],
        2025: [
          { date: new Date(2025, 0, 29), name: '農曆新年' },
          { date: new Date(2025, 0, 30), name: '農曆新年翌日' },
          { date: new Date(2025, 0, 31), name: '農曆新年第三日' },
          { date: new Date(2025, 3, 4), name: '清明節' },
          { date: new Date(2025, 3, 18), name: '耶穌受難節' },
          { date: new Date(2025, 3, 19), name: '耶穌受難節翌日' },
          { date: new Date(2025, 3, 21), name: '復活節星期一' },
          { date: new Date(2025, 4, 5), name: '佛誕' },
          { date: new Date(2025, 4, 31), name: '端午節' },
          { date: new Date(2025, 9, 6), name: '中秋節翌日' },
          { date: new Date(2025, 9, 29), name: '重陽節' },
        ],
        2026: [
          { date: new Date(2026, 1, 17), name: '農曆新年' },
          { date: new Date(2026, 1, 18), name: '農曆新年翌日' },
          { date: new Date(2026, 1, 19), name: '農曆新年第三日' },
          { date: new Date(2026, 3, 3), name: '耶穌受難節' },
          { date: new Date(2026, 3, 4), name: '耶穌受難節翌日' },
          { date: new Date(2026, 3, 6), name: '復活節星期一' },
          { date: new Date(2026, 3, 5), name: '清明節' },
          { date: new Date(2026, 4, 24), name: '佛誕' },
          { date: new Date(2026, 5, 19), name: '端午節' },
          { date: new Date(2026, 8, 25), name: '中秋節翌日' },
          { date: new Date(2026, 9, 17), name: '重陽節' },
        ],
        // 繼續添加更多年份...
        2027: [
          { date: new Date(2027, 1, 6), name: '農曆新年' },
          { date: new Date(2027, 1, 8), name: '農曆新年翌日' },
          { date: new Date(2027, 1, 9), name: '農曆新年第三日' },
          { date: new Date(2027, 2, 26), name: '耶穌受難節' },
          { date: new Date(2027, 2, 27), name: '耶穌受難節翌日' },
          { date: new Date(2027, 2, 29), name: '復活節星期一' },
          { date: new Date(2027, 3, 5), name: '清明節' },
          { date: new Date(2027, 4, 13), name: '佛誕' },
          { date: new Date(2027, 5, 9), name: '端午節' },
          { date: new Date(2027, 8, 15), name: '中秋節翌日' },
          { date: new Date(2027, 9, 7), name: '重陽節' },
        ],
        2028: [
          { date: new Date(2028, 0, 26), name: '農曆新年' },
          { date: new Date(2028, 0, 27), name: '農曆新年翌日' },
          { date: new Date(2028, 0, 28), name: '農曆新年第三日' },
          { date: new Date(2028, 3, 4), name: '清明節' },
          { date: new Date(2028, 3, 14), name: '耶穌受難節' },
          { date: new Date(2028, 3, 15), name: '耶穌受難節翌日' },
          { date: new Date(2028, 3, 17), name: '復活節星期一' },
          { date: new Date(2028, 4, 2), name: '佛誕' },
          { date: new Date(2028, 4, 28), name: '端午節' },
          { date: new Date(2028, 8, 3), name: '中秋節翌日' },
          { date: new Date(2028, 9, 26), name: '重陽節' },
        ],
        // 可以繼續添加到2035年...
      };

      // 添加該年份的特定假期
      if (completeHolidayData[year]) {
        holidays.push(...completeHolidayData[year]);
      }

      return holidays;
    },
    // 檢查是否為公眾假期
    isPublicHoliday(date, holidays) {
      return holidays.some(holiday =>
        holiday.date.getFullYear() === date.getFullYear() &&
        holiday.date.getMonth() === date.getMonth() &&
        holiday.date.getDate() === date.getDate()
      );
    },
    // 獲取指定日期的公眾假期名稱
    getHolidayName(date, holidays) {
      const holiday = holidays.find(holiday =>
        holiday.date.getFullYear() === date.getFullYear() &&
        holiday.date.getMonth() === date.getMonth() &&
        holiday.date.getDate() === date.getDate()
      );
      return holiday ? holiday.name : null;
    },
    // 格式化日期為顯示字符串
    formatDateForDisplay(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    // 計算工作天數
    calculateWorkDays(startDate, endDate) {
      if (!startDate || !endDate) {
        return {
          isValid: false,
          totalDays: 0,
          workDays: 0,
          sundaysCount: 0,
          holidaysCount: 0,
          excludedHolidays: []
        };
      }

      const start = new Date(startDate);
      const end = new Date(endDate);

      if (start > end) {
        return {
          isValid: false,
          totalDays: 0,
          workDays: 0,
          sundaysCount: 0,
          holidaysCount: 0,
          excludedHolidays: []
        };
      }

      // 計算總天數（包含開始和結束日期）
      const totalDays = Math.floor((end - start) / (1000 * 60 * 60 * 24)) + 1;

      // 獲取涉及年份的所有公眾假期
      const startYear = start.getFullYear();
      const endYear = end.getFullYear();
      let holidays = [];

      for (let year = startYear; year <= endYear; year++) {
        holidays.push(...this.getHongKongHolidays(year));
      }

      let workDays = 0;
      let sundaysCount = 0;
      let holidaysCount = 0;
      const excludedHolidays = [];
      const currentDate = new Date(start);

      while (currentDate <= end) {
        const dayOfWeek = currentDate.getDay();
        const isSunday = dayOfWeek === 0;
        const isHoliday = this.isPublicHoliday(currentDate, holidays);

        if (isSunday) {
          sundaysCount++;
        } else if (isHoliday) {
          holidaysCount++;
          const holidayName = this.getHolidayName(currentDate, holidays);
          const dateStr = this.formatDateForDisplay(currentDate);
          excludedHolidays.push(`${dateStr} ${holidayName}`);
        } else {
          // 如果不是星期日且不是公眾假期，則為工作日
          workDays++;
        }

        currentDate.setDate(currentDate.getDate() + 1);
      }

      return {
        isValid: true,
        totalDays,
        workDays,
        sundaysCount,
        holidaysCount,
        excludedHolidays
      };
    },
  },
  mounted() {
    var to_day = new Date(new Date().setDate(new Date().getDate()));
    this.filter_date_from = new Date(new Date().setFullYear(new Date().getFullYear() - 1));
    this.filter_date_to = this.getFormatedDate(to_day);
    this.dateRange = [
      this.getFormatedDate(this.filter_date_from),
      this.filter_date_to
    ];
  },
  computed: {
    users() {
      let userData = getUserData();
      let users = this.$store.state.app.onlineUsers.filter(
        (ele) => ele.userId != userData.id
      );
      users.unshift({
        userId: userData.id,
        position: userData.user_type && userData.user_type.type,
        name: userData.name,
      });

      return users;
    },
    workDaysResult() {
      return this.calculateWorkDays(this.workDaysStartDate, this.workDaysEndDate);
    },
  },
  watch: {
    dateRange: {
      handler() {
        [this.filter_date_from, this.filter_date_to] = this.dateRange;
        if (typeof this.filter_date_from === "object") {
          this.filter_date_from = this.getFormatedDate(this.filter_date_from);
          this.filter_date_to = this.getFormatedDate(this.filter_date_to);
        }
      },
    },
  },
  setup() {
    const messageList = ref(null);

    const fetchMessages = () => {
      axiosIns
        .get("/messages/", {
          params: {
            q: null,
          },
        })
        .then((response) => (messageList.value = response.data.messages))
        .catch((error) => console.log(error));
    };

    const infoData = ref(null);
    const fetchInfo = () => {
      axiosIns
        .get("/info", {
          params: {},
        })
        .then((response) => {
          infoData.value = response.data;
        })
        .catch((error) => console.log(error));
    };

    const invoiceBalanceList = ref([]);
    const expandedInvoiceId = ref(null);
    const invoiceBalanceFields = [
      { key: "invoice_number", label: "發票編號" },
      { key: "total_amount", label: "發票總額", formatter: formatCurrency },
      { key: "total_cost", label: "總成本" },
      { key: "balance", label: "結餘", formatter: formatCurrency },
    ];
    const fetchInvoiceBalance = () => {
      axiosIns
        .get("/info/invoice-balance")
        .then((response) => {
          invoiceBalanceList.value = response.data.invoice_balance_list || [];
        })
        .catch((error) => console.log(error));
    };
    const toggleCostExpand = (id) => {
      expandedInvoiceId.value = expandedInvoiceId.value === id ? null : id;
    };

    onMounted(() => {
      fetchMessages();
      fetchInfo();
      fetchInvoiceBalance();
    });
    return {
      fetchMessages,
      fetchInfo,
      messageList,
      infoData,
      invoiceBalanceList,
      expandedInvoiceId,
      invoiceBalanceFields,
      fetchInvoiceBalance,
      toggleCostExpand,
    };
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/variables/_variables.scss";
@import "@core/scss/vue/libs/vue-select.scss";

.overflow-box-content {
  overflow-y: auto;
  // height: 300px;
  padding: 0 10px;
}

.tabs.type-1 {
  .nav-pills {
    margin-bottom: 1rem;
    flex-wrap: nowrap;
    overflow-x: auto;

    .nav-item {
      margin-right: 1rem;

      a {
        border-radius: 0.5rem;
        padding: 0.15rem 0.5rem;
        white-space: nowrap;

        &:not(.active) {
          background-color: transparent;
        }
      }
    }
  }
}

.dashboard-box .body {
  height: 100%;
  width: 100%;
}

.message-box {
  .top {
    a {
      background-color: $primary;
      padding: 0.25rem 1rem;
      color: #fff;
    }
  }

  .info {
    font-size: 12px;

    .header {
      color: #fff;
      background: #5e90c4;
    }

    .body {
      color: #384251;
      background: #eeeeee;
    }
  }

  .work-days-calculator {
    border-top: 1px solid #e9ecef;
    padding-top: 0.5rem;

    h6 {
      color: #495057;
      font-weight: 600;
    }

    .form-label {
      font-size: 0.75rem;
      color: #6c757d;
      margin-bottom: 0.25rem;
    }

    .work-days-result {
      border: 1px solid #dee2e6;
      font-size: 0.875rem;

      .text-primary {
        color: $primary !important;
        font-size: 1rem;
      }

      .holiday-list {
        margin-top: 0.5rem;

        .holiday-items {
          max-height: 120px;
          overflow-y: auto;

          .holiday-item {
            font-size: 0.7rem;
            padding: 0.2rem 0.4rem;
            background-color: #6c757d;
            color: white;
            border-radius: 0.25rem;
            display: inline-block;
            white-space: nowrap;
          }
        }
      }
    }
  }
}

.invoice-balance-table-wrapper {
  max-height: 360px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 0.25rem;
}

.invoice-balance-thead {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  background: #f8f9fa;
  font-weight: 600;
  font-size: 1rem;
  flex-shrink: 0;
  position: sticky;
  top: 0;
  z-index: 1;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.invoice-balance-body {
  overflow-y: auto;
  flex: 1;
  min-height: 0;
}

.invoice-balance-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  font-size: 0.9375rem;
  align-items: start;
}

.invoice-balance-row-striped:nth-child(even) {
  background-color: rgba(0, 0, 0, 0.03);
}

.invoice-balance-td {
  word-break: break-word;
}

.invoice-balance-td .cost-breakdown {
  font-size: 0.875rem;
}

@media screen and (min-width: 1200px) {

  .invoice-balance-box {
    width: 43%;
    max-width: 43%;
    flex: 0 0 43%;
  }

  .message-box {
    width: 35%;
    max-width: 35%;
    flex: 0 0 35%;
  }

  .online-box {
    width: 22%;
    max-width: 22%;
    flex: 0 0 22%;
  }

  // .customer-dashboard {
  //   .invoice-balance-box {
  //     width: 50%;
  //     max-width: 50%;
  //     flex: 0 0 50%;
  //   }

  //   .message-box {
  //     width: 50%;
  //     max-width: 50%;
  //     flex: 0 0 50%;
  //   }
  // }
}
@media screen and (max-width: 1200px) {
 
  .invoice-balance-box {
    width: 100%;
    max-width: 100%;
    flex: 0 0 100%;
  }

  .message-box {
    width: 50%;
    max-width: 50%;
    flex: 0 0 50%;
  }

  .online-box {
    width: 50%;
    max-width: 50%;
    flex: 0 0 50%;
  }
}

.project-expense-box {

  .el-date-editor--daterange.el-input,
  .el-date-editor--daterange.el-input__inner,
  .el-date-editor--timerange.el-input,
  .el-date-editor--timerange.el-input__inner {
    width: 300px;
  }

  .el-date-editor .el-range__close-icon {
    display: none;
  }

  .el-range-separator {
    width: 8%;
    text-align: center;
  }
}


@media sceen and (max-width: 1200px) {
  .dashboard-info-box .info {
    left: 1.5rem;
    top: 1.5rem;
  }
}
</style>